import readableBytes from '../../utilities/readableBytes';
import readableNumber from '../../utilities/readableNumber';

export const EXPORT_STORAGE_FULL_CODE = 'STORAGE_FULL';

export function normalizeErrorField(value) {
  if (typeof value !== 'string') return '';
  return value.trim();
}

export function normalizeIsCapped(value) {
  if (value === true) return true;
  if (typeof value === 'string') {
    return value.toLowerCase() === 'true';
  }
  return false;
}

export function normalizeStatus(status) {
  const normalized = typeof status === 'string' ? status.toLowerCase() : '';
  if (['pending', 'ready', 'failed'].includes(normalized)) {
    return normalized;
  }
  return 'unknown';
}

export function formatRequestedAt(createdAt) {
  const parsedDate = new Date(createdAt);
  if (Number.isNaN(parsedDate.getTime())) {
    return createdAt || '-';
  }
  return parsedDate.toLocaleString();
}

export function formatRecordCount(value) {
  if (typeof value !== 'number' || !Number.isFinite(value) || value < 0) {
    return '-';
  }
  return readableNumber(value, 1);
}

export function formatByteSize(value) {
  if (typeof value !== 'number' || !Number.isFinite(value) || value < 0) {
    return '-';
  }
  try {
    return readableBytes(value, 1);
  } catch (_) {
    return '-';
  }
}

export function formatStatus(status) {
  const normalized = normalizeStatus(status);
  return normalized.charAt(0).toUpperCase() + normalized.slice(1);
}

export function statusVariant(status) {
  const normalized = normalizeStatus(status);
  if (normalized === 'ready') return 'success';
  if (normalized === 'failed') return 'danger';
  if (normalized === 'pending') return 'warning';
  return 'secondary';
}

export function shouldShowStatusDetails(exportItem) {
  const status = normalizeStatus(exportItem.status);
  return status === 'failed' || normalizeIsCapped(exportItem.isCapped);
}

export function statusDetailsTooltip(exportItem) {
  const status = normalizeStatus(exportItem.status);
  if (status === 'failed') {
    const details = [];
    if (exportItem.errorCode) {
      details.push(`Code: ${exportItem.errorCode}`);
    }
    if (exportItem.errorMessage) {
      details.push(exportItem.errorMessage);
    }
    if (!details.length) {
      return 'Export failed. No details provided.';
    }
    return details.join(' | ');
  }
  if (normalizeIsCapped(exportItem.isCapped)) {
    return 'Export reached cap; file may be partial.';
  }
  return '';
}

export function canDownloadExport(exportItem) {
  return normalizeStatus(exportItem.status) === 'ready';
}

export function hasPendingExports(items = []) {
  return items.some((exportItem) => normalizeStatus(exportItem.status) === 'pending');
}

export function mapExportItemToTableItem(exportItem) {
  return {
    ...exportItem,
    requestedAt: formatRequestedAt(exportItem.createdAt),
    status: normalizeStatus(exportItem.status),
    targetIndex: exportItem.targetIndex || '-',
    startAt: formatRequestedAt(exportItem.startTime),
    endAt: formatRequestedAt(exportItem.endTime),
    numRecords: formatRecordCount(exportItem.numRecords),
    numBytes: formatByteSize(exportItem.numBytes),
    errorCode: normalizeErrorField(exportItem.errorCode),
    errorMessage: normalizeErrorField(exportItem.errorMessage),
    isCapped: normalizeIsCapped(exportItem.isCapped),
  };
}

export function mapExportItemsToTableItems(items = []) {
  return items.map((exportItem) => mapExportItemToTableItem(exportItem));
}
